module.exports = __webpack_public_path__ + "static/media/rv-repair.b9871b5c.png";